import React from "react";
import exp from "constants";
import ScrollToTopOnMount from "./ScrollToTopOnMount";

function Orari() {
    return(
        <div style={{margin: "6em 0 0 2em"}} id="orari">
            <h1 style={{fontFamily: "Hammersmith One", color: "#64A6D0"}}>ORARI</h1>
            <hr/>
            <div style={{display:"flex", flexDirection: "column", alignContent:"center", justifyContent: "center", margin: "auto", width: "100%"}}>
                    <table className="table text-center m-auto">
                        <thead >
                        <tr>
                            <th scope="row"></th>
                            <th>Apertura</th>
                            <th>Ufficio</th>

                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <th scope="row">Lun</th>
                            <td>7 - 22.30</td>
                            <td>9 - 22</td>

                        </tr>
                        <tr>
                            <th scope="row">Mar</th>
                            <td>9 - 22.30</td>
                            <td>9 - 22</td>
                        </tr>
                        <tr>
                            <th scope="row">Mer</th>
                            <td>7 - 22.30</td>
                            <td>9 - 22</td>
                        </tr>
                        <tr>
                            <th scope="row">Gio</th>
                            <td>9 - 22.30</td>
                            <td>9 - 22</td>
                        </tr>
                        <tr>
                            <th scope="row">Ven</th>
                            <td>7 - 22.30</td>
                            <td>9 - 22</td>
                        </tr>
                        <tr>
                            <th scope="row">Sab</th>
                            <td>9 - 19.30</td>
                            <td>9 - 13 / 14 - 19</td>
                        </tr>
                        <tr>
                            <th scope="row">Dom</th>
                            <td>9 - 13.30</td>
                            <td>9 - 13</td>
                        </tr>
                        </tbody>
                    </table>
            </div>
        </div>
    )
}

export default Orari